import React from "react";
import "../Page.css";
import "./style.css";
import google_search_logo from "../../Assets/integration/google_search_console.svg"
import googleAna from "../../Assets/integration/google-analytics.svg";
import KeyValueBox from "./keyValueBox/keyValueBox";
import CodeBox from "./codeBoxComponent/codeBox";

const GoogleAnalytics = () => {
  
  return (
    <div className="DashboardPage" style={{ alignItems: "start", justifyContent: "start" }}>
      <div className="component-card">
        <div className="header_integration">
          <div className="name_header_int">
            
            <div className="int_heading_content">
            <h4>Google Analytics</h4>
              <span className="active_state active">Active</span>
              
            </div>
            
          </div>
          <img className="int_logo" src={googleAna} />
          
        </div>

        <KeyValueBox label={"Measurement ID"} value={"YOUR_VERIFICATION_CODE_HERE"} />
      </div>
    </div>
  );
};

export default GoogleAnalytics;